import { ToastContainer } from 'react-toastify';
import RouterData from './routes';
import { RolesProvider } from './context/RolesContext';

function App() {
  return (
    <>
    <RolesProvider>

      <RouterData />
      <ToastContainer />
      </RolesProvider>

    </>
  );  
}

export default App;
